import React from 'react';
import { SkillStats } from '../../models/userStats';

interface StatsSummaryCardProps {
    stats: SkillStats;
    title: string;
    subtitle?: string;
    gradient?: string;
}

const StatsSummaryCard: React.FC<StatsSummaryCardProps> = ({
    stats,
    title,
    subtitle,
    gradient = 'from-purple-600 to-indigo-600'
}) => {
    const categories = [
        { key: 'rail' as keyof SkillStats, label: 'Rail/Jib', icon: '🛹' },
        { key: 'jump' as keyof SkillStats, label: 'Jump', icon: '🚀' },
        { key: 'style' as keyof SkillStats, label: 'Style', icon: '✨' },
        { key: 'off_snow' as keyof SkillStats, label: 'Off-Snow', icon: '💪' },
        { key: 'mountain' as keyof SkillStats, label: 'Freeride', icon: '⛰️' },
        { key: 'halfpipe' as keyof SkillStats, label: 'Halfpipe', icon: '🏂' }
    ];

    const averageScore = Math.round(
        Object.values(stats).reduce((sum, val) => sum + val, 0) / Object.values(stats).length
    );

    return (
        <div className={`relative overflow-hidden rounded-2xl p-4 bg-gradient-to-br ${gradient} shadow-xl`}>
            {/* Animated background effect */}
            <div className="absolute inset-0 bg-white/5 backdrop-blur-3xl"></div>

            <div className="relative z-10">
                {/* Header */}
                <div className="flex items-start justify-between mb-4">
                    <div>
                        <h3 className="text-white font-bold text-lg">{title}</h3>
                        {subtitle && (
                            <p className="text-white/70 text-xs mt-1">{subtitle}</p>
                        )}
                    </div>
                    <div className="text-right">
                        <div className="text-white font-bold text-3xl">{averageScore}</div>
                        <div className="text-white/70 text-xs">Rating</div>
                    </div>
                </div>

                {/* Stats Grid */}
                <div className="grid grid-cols-3 gap-3">
                    {categories.map(category => (
                        <div
                            key={category.key}
                            className="bg-white/10 backdrop-blur-sm rounded-xl p-3 border border-white/20"
                        >
                            <div className="text-2xl mb-1">{category.icon}</div>
                            <div className="text-white font-bold text-lg">
                                {stats[category.key]}
                            </div>
                            <div className="text-white/70 text-xs font-medium">
                                {category.label}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default StatsSummaryCard;
